export enum EmitType {
  Open,
  Dismiss,
  Data
}
